const isMobileViewport = viewport => viewport === "smallMobile" || viewport === "mediumMobile" || viewport === "largeMobile";

export default isMobileViewport;